import { Button } from 'app/components/ui/Button'
import { Form } from 'app/components/ui/Form'
import {
  removeAuthFromLocalStorage,
  storeAuthToLocalStorage,
} from 'app/contexts/AuthenticationProvider/persistAuthToken'
import {
  getMswDataConfigFromLocalStorage,
  removeMswDataConfigToLocalStorage,
  storeMswDataConfigToLocalStorage,
} from 'app/mocks/utils/dataConfigUtils'
import { protectedRoutes, ROUTE_BASE_URL } from 'app/routing/routes'
import React from 'react'
import styled from 'styled-components'

import { MswDevToolsInnerForm } from '../MswDevToolsInnerForm'

import {
  adaptFormDataToLocalStorage,
  adaptLocalStorageToFormData,
  MswDevToolsFormData,
  mswDevToolsFormDefaultValues,
  mswDevToolsFormValidationSchema,
} from './form'

export const MswDevToolsForm = (): JSX.Element => {
  const initialData = getMswDataConfigFromLocalStorage()

  const onSubmit = (data: MswDevToolsFormData) => {
    storeMswDataConfigToLocalStorage(adaptFormDataToLocalStorage(data))

    // An auth token is needed to login the user,
    // otherwise the "getUser" api call will not be executed, and the mocked handler consequentially
    storeAuthToLocalStorage('auth')

    window.location.href = ROUTE_BASE_URL
      ? `/${ROUTE_BASE_URL}${protectedRoutes.dashboard.path}`
      : protectedRoutes.dashboard.path
  }

  const onReset = () => {
    removeMswDataConfigToLocalStorage()

    removeAuthFromLocalStorage()

    window.location.href = ROUTE_BASE_URL
      ? `/${ROUTE_BASE_URL}${protectedRoutes.dashboard.path}`
      : protectedRoutes.dashboard.path
  }

  return (
    <Form<MswDevToolsFormData>
      defaultValues={
        initialData
          ? adaptLocalStorageToFormData(initialData)
          : mswDevToolsFormDefaultValues
      }
      validationSchema={mswDevToolsFormValidationSchema}
      onSubmit={onSubmit}
      hideDevTool
    >
      <MswDevToolsInnerForm />
      <ActionsWrapper>
        <Button
          onClick={(e) => {
            // Avoid trigger
            e.preventDefault()
            e.stopPropagation()
            onReset()
          }}
          variant='grey'
        >
          Reset
        </Button>
        <Button type='submit'>Aggiorna</Button>
      </ActionsWrapper>
    </Form>
  )
}

const ActionsWrapper = styled.div`
  text-align: right;

  button:first-child {
    margin-right: 1rem;
  }
`
